"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMIL CustomerService
 * The EMIL CustomerService API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoliciesApi = exports.PoliciesApiFactory = exports.PoliciesApiFp = exports.PoliciesApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
// URLSearchParams not necessarily used
/**
 * PoliciesApi - axios parameter creator
 * @export
 */
var PoliciesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get detailed policy that belongs to a customer;        the details are filtered to return only the current       version and the interval timeline that the provided date is included.       If the date is not specified, the system will return the whole timeline.
         * @summary Get current version details
         * @param {string} policyCode The policy code.
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {string} [timesliceDate] This date is used to filter data of the policy, to select the appropriate timeslice.       If no date is specified, the system returns all the timeslices.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPolicyDataByDate: function (policyCode, customerCode, timesliceDate, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'policyCode' is not null or undefined
                    (0, common_1.assertParamExists)('getCustomerPolicyDataByDate', 'policyCode', policyCode);
                    // verify required parameter 'customerCode' is not null or undefined
                    (0, common_1.assertParamExists)('getCustomerPolicyDataByDate', 'customerCode', customerCode);
                    localVarPath = "/v1/customers/{customerCode}/policies/{policyCode}/current-version"
                        .replace("{".concat("policyCode", "}"), encodeURIComponent(String(policyCode)))
                        .replace("{".concat("customerCode", "}"), encodeURIComponent(String(customerCode)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (timesliceDate !== undefined) {
                        localVarQueryParameter['timesliceDate'] = timesliceDate;
                    }
                    if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                        localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get detailed policy that belongs to a customer; the details can be expanded using expand query parameter.
         * @summary Get policy details
         * @param {string} policyCode The policy code.
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {string} [expand] Fields to expand response by - [versions, premiumItems]
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicy: function (policyCode, customerCode, expand, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'policyCode' is not null or undefined
                    (0, common_1.assertParamExists)('getPolicy', 'policyCode', policyCode);
                    // verify required parameter 'customerCode' is not null or undefined
                    (0, common_1.assertParamExists)('getPolicy', 'customerCode', customerCode);
                    localVarPath = "/v1/customers/{customerCode}/policies/{policyCode}"
                        .replace("{".concat("policyCode", "}"), encodeURIComponent(String(policyCode)))
                        .replace("{".concat("customerCode", "}"), encodeURIComponent(String(customerCode)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (expand !== undefined) {
                        localVarQueryParameter['expand'] = expand;
                    }
                    if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                        localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * List all the policies that belong to a customer, the policies can be filtered by policy code, policy number.
         * @summary List policies
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {any} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 100. Default: 10.
         * @param {any} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1,     your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {any} [filter] Filter the response by one or multiple fields.     In general, fetching filtered responses will conserve bandwidth and reduce response time.
         * @param {any} [filters] Filter the response by one or multiple fields.     In general, fetching filtered responses will conserve bandwidth and reduce response time.
         * @param {any} [search] Search the list by any field. For instance, if you want to search by code     add code&#x3D;xxx in order to fetch the result.
         * @param {any} [order] The order parameter determines how the results should be sorted according to a specified field.     It functions similarly to an SQL ORDER BY.     Sorting can be performed in either ascending (ASC) or descending (DESC) order.     Default: ASC.
         * @param {any} [expand] Use this parameter to fetch additional information about the list items.     The expand query parameter increases the set of fields that appear in the response in     addition to the default ones.     Expanding resources can reduce the number of API calls required to accomplish a task.     However, use this with parsimony as some expanded fields can drastically increase payload size.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicies: function (customerCode, pageSize, pageToken, filter, filters, search, order, expand, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'customerCode' is not null or undefined
                    (0, common_1.assertParamExists)('listPolicies', 'customerCode', customerCode);
                    localVarPath = "/v1/customers/{customerCode}/policies"
                        .replace("{".concat("customerCode", "}"), encodeURIComponent(String(customerCode)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (pageToken !== undefined) {
                        localVarQueryParameter['pageToken'] = pageToken;
                    }
                    if (filter !== undefined) {
                        localVarQueryParameter['filter'] = filter;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    if (order !== undefined) {
                        localVarQueryParameter['order'] = order;
                    }
                    if (expand !== undefined) {
                        localVarQueryParameter['expand'] = expand;
                    }
                    if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                        localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Request to update an existing policy by customer.
         * @summary Request policy update
         * @param {string} policyCode The code of the policy that the customer wants to update.
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {RequestPolicyUpdateRequestDto} requestPolicyUpdateRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPolicyUpdate: function (policyCode, customerCode, requestPolicyUpdateRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'policyCode' is not null or undefined
                    (0, common_1.assertParamExists)('requestPolicyUpdate', 'policyCode', policyCode);
                    // verify required parameter 'customerCode' is not null or undefined
                    (0, common_1.assertParamExists)('requestPolicyUpdate', 'customerCode', customerCode);
                    // verify required parameter 'requestPolicyUpdateRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('requestPolicyUpdate', 'requestPolicyUpdateRequestDto', requestPolicyUpdateRequestDto);
                    localVarPath = "/v1/customers/{customerCode}/policies/{policyCode}/request-update"
                        .replace("{".concat("policyCode", "}"), encodeURIComponent(String(policyCode)))
                        .replace("{".concat("customerCode", "}"), encodeURIComponent(String(customerCode)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                        localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestPolicyUpdateRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Request to terminate an existing policy by customer.
         * @summary Terminate a policy
         * @param {string} policyCode The code of the policy that the customer wants to terminate.
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {TerminateCustomerPolicyRequestDto} terminateCustomerPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateCustomerPolicy: function (policyCode, customerCode, terminateCustomerPolicyRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'policyCode' is not null or undefined
                    (0, common_1.assertParamExists)('terminateCustomerPolicy', 'policyCode', policyCode);
                    // verify required parameter 'customerCode' is not null or undefined
                    (0, common_1.assertParamExists)('terminateCustomerPolicy', 'customerCode', customerCode);
                    // verify required parameter 'terminateCustomerPolicyRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('terminateCustomerPolicy', 'terminateCustomerPolicyRequestDto', terminateCustomerPolicyRequestDto);
                    localVarPath = "/v1/customers/{customerCode}/policies/{policyCode}/terminate"
                        .replace("{".concat("policyCode", "}"), encodeURIComponent(String(policyCode)))
                        .replace("{".concat("customerCode", "}"), encodeURIComponent(String(customerCode)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                        localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(terminateCustomerPolicyRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * API to upload and attach documents to a policy.
         * @summary Upload policy documents
         * @param {string} customerCode
         * @param {string} policyCode The policy code to identify a policy.
         * @param {UploadCustomerPolicyDocumentsRequestDto} uploadCustomerPolicyDocumentsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomerPolicyDocuments: function (customerCode, policyCode, uploadCustomerPolicyDocumentsRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'customerCode' is not null or undefined
                    (0, common_1.assertParamExists)('uploadCustomerPolicyDocuments', 'customerCode', customerCode);
                    // verify required parameter 'policyCode' is not null or undefined
                    (0, common_1.assertParamExists)('uploadCustomerPolicyDocuments', 'policyCode', policyCode);
                    // verify required parameter 'uploadCustomerPolicyDocumentsRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('uploadCustomerPolicyDocuments', 'uploadCustomerPolicyDocumentsRequestDto', uploadCustomerPolicyDocumentsRequestDto);
                    localVarPath = "/v1/customers/{customerCode}/policies/{policyCode}/documents"
                        .replace("{".concat("customerCode", "}"), encodeURIComponent(String(customerCode)))
                        .replace("{".concat("policyCode", "}"), encodeURIComponent(String(policyCode)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(uploadCustomerPolicyDocumentsRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Withdraw policy by customer.
         * @summary Withdraw the policy
         * @param {string} policyCode The code of the policy that the customer wants to withdraw.
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawCustomerPolicy: function (policyCode, customerCode, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'policyCode' is not null or undefined
                    (0, common_1.assertParamExists)('withdrawCustomerPolicy', 'policyCode', policyCode);
                    // verify required parameter 'customerCode' is not null or undefined
                    (0, common_1.assertParamExists)('withdrawCustomerPolicy', 'customerCode', customerCode);
                    localVarPath = "/v1/customers/{customerCode}/policies/{policyCode}/withdraw"
                        .replace("{".concat("policyCode", "}"), encodeURIComponent(String(policyCode)))
                        .replace("{".concat("customerCode", "}"), encodeURIComponent(String(customerCode)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                        baseAccessToken = configuration.accessToken;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                        localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.PoliciesApiAxiosParamCreator = PoliciesApiAxiosParamCreator;
/**
 * PoliciesApi - functional programming interface
 * @export
 */
var PoliciesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PoliciesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get detailed policy that belongs to a customer;        the details are filtered to return only the current       version and the interval timeline that the provided date is included.       If the date is not specified, the system will return the whole timeline.
         * @summary Get current version details
         * @param {string} policyCode The policy code.
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {string} [timesliceDate] This date is used to filter data of the policy, to select the appropriate timeslice.       If no date is specified, the system returns all the timeslices.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPolicyDataByDate: function (policyCode, customerCode, timesliceDate, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCustomerPolicyDataByDate(policyCode, customerCode, timesliceDate, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get detailed policy that belongs to a customer; the details can be expanded using expand query parameter.
         * @summary Get policy details
         * @param {string} policyCode The policy code.
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {string} [expand] Fields to expand response by - [versions, premiumItems]
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicy: function (policyCode, customerCode, expand, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPolicy(policyCode, customerCode, expand, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * List all the policies that belong to a customer, the policies can be filtered by policy code, policy number.
         * @summary List policies
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {any} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 100. Default: 10.
         * @param {any} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1,     your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {any} [filter] Filter the response by one or multiple fields.     In general, fetching filtered responses will conserve bandwidth and reduce response time.
         * @param {any} [filters] Filter the response by one or multiple fields.     In general, fetching filtered responses will conserve bandwidth and reduce response time.
         * @param {any} [search] Search the list by any field. For instance, if you want to search by code     add code&#x3D;xxx in order to fetch the result.
         * @param {any} [order] The order parameter determines how the results should be sorted according to a specified field.     It functions similarly to an SQL ORDER BY.     Sorting can be performed in either ascending (ASC) or descending (DESC) order.     Default: ASC.
         * @param {any} [expand] Use this parameter to fetch additional information about the list items.     The expand query parameter increases the set of fields that appear in the response in     addition to the default ones.     Expanding resources can reduce the number of API calls required to accomplish a task.     However, use this with parsimony as some expanded fields can drastically increase payload size.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicies: function (customerCode, pageSize, pageToken, filter, filters, search, order, expand, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listPolicies(customerCode, pageSize, pageToken, filter, filters, search, order, expand, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Request to update an existing policy by customer.
         * @summary Request policy update
         * @param {string} policyCode The code of the policy that the customer wants to update.
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {RequestPolicyUpdateRequestDto} requestPolicyUpdateRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPolicyUpdate: function (policyCode, customerCode, requestPolicyUpdateRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.requestPolicyUpdate(policyCode, customerCode, requestPolicyUpdateRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Request to terminate an existing policy by customer.
         * @summary Terminate a policy
         * @param {string} policyCode The code of the policy that the customer wants to terminate.
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {TerminateCustomerPolicyRequestDto} terminateCustomerPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateCustomerPolicy: function (policyCode, customerCode, terminateCustomerPolicyRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.terminateCustomerPolicy(policyCode, customerCode, terminateCustomerPolicyRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * API to upload and attach documents to a policy.
         * @summary Upload policy documents
         * @param {string} customerCode
         * @param {string} policyCode The policy code to identify a policy.
         * @param {UploadCustomerPolicyDocumentsRequestDto} uploadCustomerPolicyDocumentsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomerPolicyDocuments: function (customerCode, policyCode, uploadCustomerPolicyDocumentsRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadCustomerPolicyDocuments(customerCode, policyCode, uploadCustomerPolicyDocumentsRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Withdraw policy by customer.
         * @summary Withdraw the policy
         * @param {string} policyCode The code of the policy that the customer wants to withdraw.
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawCustomerPolicy: function (policyCode, customerCode, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.withdrawCustomerPolicy(policyCode, customerCode, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PoliciesApiFp = PoliciesApiFp;
/**
 * PoliciesApi - factory interface
 * @export
 */
var PoliciesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PoliciesApiFp)(configuration);
    return {
        /**
         * Get detailed policy that belongs to a customer;        the details are filtered to return only the current       version and the interval timeline that the provided date is included.       If the date is not specified, the system will return the whole timeline.
         * @summary Get current version details
         * @param {string} policyCode The policy code.
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {string} [timesliceDate] This date is used to filter data of the policy, to select the appropriate timeslice.       If no date is specified, the system returns all the timeslices.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPolicyDataByDate: function (policyCode, customerCode, timesliceDate, authorization, options) {
            return localVarFp.getCustomerPolicyDataByDate(policyCode, customerCode, timesliceDate, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get detailed policy that belongs to a customer; the details can be expanded using expand query parameter.
         * @summary Get policy details
         * @param {string} policyCode The policy code.
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {string} [expand] Fields to expand response by - [versions, premiumItems]
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicy: function (policyCode, customerCode, expand, authorization, options) {
            return localVarFp.getPolicy(policyCode, customerCode, expand, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List all the policies that belong to a customer, the policies can be filtered by policy code, policy number.
         * @summary List policies
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {any} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 100. Default: 10.
         * @param {any} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1,     your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {any} [filter] Filter the response by one or multiple fields.     In general, fetching filtered responses will conserve bandwidth and reduce response time.
         * @param {any} [filters] Filter the response by one or multiple fields.     In general, fetching filtered responses will conserve bandwidth and reduce response time.
         * @param {any} [search] Search the list by any field. For instance, if you want to search by code     add code&#x3D;xxx in order to fetch the result.
         * @param {any} [order] The order parameter determines how the results should be sorted according to a specified field.     It functions similarly to an SQL ORDER BY.     Sorting can be performed in either ascending (ASC) or descending (DESC) order.     Default: ASC.
         * @param {any} [expand] Use this parameter to fetch additional information about the list items.     The expand query parameter increases the set of fields that appear in the response in     addition to the default ones.     Expanding resources can reduce the number of API calls required to accomplish a task.     However, use this with parsimony as some expanded fields can drastically increase payload size.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicies: function (customerCode, pageSize, pageToken, filter, filters, search, order, expand, authorization, options) {
            return localVarFp.listPolicies(customerCode, pageSize, pageToken, filter, filters, search, order, expand, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Request to update an existing policy by customer.
         * @summary Request policy update
         * @param {string} policyCode The code of the policy that the customer wants to update.
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {RequestPolicyUpdateRequestDto} requestPolicyUpdateRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPolicyUpdate: function (policyCode, customerCode, requestPolicyUpdateRequestDto, authorization, options) {
            return localVarFp.requestPolicyUpdate(policyCode, customerCode, requestPolicyUpdateRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Request to terminate an existing policy by customer.
         * @summary Terminate a policy
         * @param {string} policyCode The code of the policy that the customer wants to terminate.
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {TerminateCustomerPolicyRequestDto} terminateCustomerPolicyRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateCustomerPolicy: function (policyCode, customerCode, terminateCustomerPolicyRequestDto, authorization, options) {
            return localVarFp.terminateCustomerPolicy(policyCode, customerCode, terminateCustomerPolicyRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * API to upload and attach documents to a policy.
         * @summary Upload policy documents
         * @param {string} customerCode
         * @param {string} policyCode The policy code to identify a policy.
         * @param {UploadCustomerPolicyDocumentsRequestDto} uploadCustomerPolicyDocumentsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomerPolicyDocuments: function (customerCode, policyCode, uploadCustomerPolicyDocumentsRequestDto, options) {
            return localVarFp.uploadCustomerPolicyDocuments(customerCode, policyCode, uploadCustomerPolicyDocumentsRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Withdraw policy by customer.
         * @summary Withdraw the policy
         * @param {string} policyCode The code of the policy that the customer wants to withdraw.
         * @param {string} customerCode The customer code or \&quot;me\&quot; for the currently logged in customer.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawCustomerPolicy: function (policyCode, customerCode, authorization, options) {
            return localVarFp.withdrawCustomerPolicy(policyCode, customerCode, authorization, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PoliciesApiFactory = PoliciesApiFactory;
/**
 * PoliciesApi - object-oriented interface
 * @export
 * @class PoliciesApi
 * @extends {BaseAPI}
 */
var PoliciesApi = /** @class */ (function (_super) {
    __extends(PoliciesApi, _super);
    function PoliciesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get detailed policy that belongs to a customer;        the details are filtered to return only the current       version and the interval timeline that the provided date is included.       If the date is not specified, the system will return the whole timeline.
     * @summary Get current version details
     * @param {PoliciesApiGetCustomerPolicyDataByDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.getCustomerPolicyDataByDate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).getCustomerPolicyDataByDate(requestParameters.policyCode, requestParameters.customerCode, requestParameters.timesliceDate, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get detailed policy that belongs to a customer; the details can be expanded using expand query parameter.
     * @summary Get policy details
     * @param {PoliciesApiGetPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.getPolicy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).getPolicy(requestParameters.policyCode, requestParameters.customerCode, requestParameters.expand, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List all the policies that belong to a customer, the policies can be filtered by policy code, policy number.
     * @summary List policies
     * @param {PoliciesApiListPoliciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.listPolicies = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).listPolicies(requestParameters.customerCode, requestParameters.pageSize, requestParameters.pageToken, requestParameters.filter, requestParameters.filters, requestParameters.search, requestParameters.order, requestParameters.expand, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Request to update an existing policy by customer.
     * @summary Request policy update
     * @param {PoliciesApiRequestPolicyUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.requestPolicyUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).requestPolicyUpdate(requestParameters.policyCode, requestParameters.customerCode, requestParameters.requestPolicyUpdateRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Request to terminate an existing policy by customer.
     * @summary Terminate a policy
     * @param {PoliciesApiTerminateCustomerPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.terminateCustomerPolicy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).terminateCustomerPolicy(requestParameters.policyCode, requestParameters.customerCode, requestParameters.terminateCustomerPolicyRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * API to upload and attach documents to a policy.
     * @summary Upload policy documents
     * @param {PoliciesApiUploadCustomerPolicyDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.uploadCustomerPolicyDocuments = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).uploadCustomerPolicyDocuments(requestParameters.customerCode, requestParameters.policyCode, requestParameters.uploadCustomerPolicyDocumentsRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Withdraw policy by customer.
     * @summary Withdraw the policy
     * @param {PoliciesApiWithdrawCustomerPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.withdrawCustomerPolicy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).withdrawCustomerPolicy(requestParameters.policyCode, requestParameters.customerCode, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PoliciesApi;
}(base_1.BaseAPI));
exports.PoliciesApi = PoliciesApi;
